<div class="filter-bar">
  @for (col of activeCols(); track col.field) {
    <span class="fchip" (click)="editing.set(col); ep.toggle($event)">
      <i class="pi" [ngClass]="icon(col)"></i>
      <span class="fl">{{ col.header }}</span>
      <span class="fv">{{ valueLabel(col) }}</span>
      <button type="button" class="x" aria-label="Rimuovi filtro" (click)="$event.stopPropagation(); remove(col)">
        <i class="pi pi-times"></i>
      </button>
    </span>
  }
  <button type="button" class="fadd" (click)="adding.set(null); search.set(''); ap.toggle($event)">
    <i class="pi pi-plus"></i> Aggiungi filtro
  </button>
  @if (activeCols().length) {
    <button type="button" class="fclear" (click)="clear()">Azzera</button>
  }
</div>

<p-popover #ap styleClass="filter-pop">
  @if (!adding()) {
    <div class="pop-search">
      <i class="pi pi-search"></i>
      <input type="text" placeholder="Filtra per ..." [ngModel]="search()" (ngModelChange)="search.set($event)" />
    </div>
    <ul class="field-list">
      @for (col of availableCols(); track col.field) {
        <li (click)="adding.set(col)"><i class="pi" [ngClass]="icon(col)"></i> {{ col.header }}</li>
      } @empty {
        <li class="none">Nessun filtro disponibile</li>
      }
    </ul>
  } @else {
    <button type="button" class="pop-back" (click)="adding.set(null)">
      <i class="pi pi-chevron-left"></i> {{ adding().header }}
    </button>
    <ng-container *ngTemplateOutlet="editor; context: { $implicit: adding(), pop: ap }"></ng-container>
  }
</p-popover>

<p-popover #ep styleClass="filter-pop">
  @if (editing()) {
    <div class="pop-title">{{ editing().header }}</div>
    <ng-container *ngTemplateOutlet="editor; context: { $implicit: editing(), pop: ep }"></ng-container>
  }
</p-popover>

<ng-template #editor let-col let-pop="pop">
  @if (col.type === 'select') {
    <ul class="field-list">
      @for (o of col.option; track o.value) {
        <li [class.sel]="value(col) === o.value" (click)="pick(col, o.value, pop)">{{ o.label }}</li>
      }
    </ul>
  } @else if (col.type === 'date') {
    <p-datepicker [ngModel]="value(col)" (ngModelChange)="pick(col, $event, pop)" dataType="string"
      dateFormat="yy-mm-dd" [inline]="true"></p-datepicker>
  } @else {
    <div class="pop-text">
      <input type="text" pInputText #t [placeholder]="col.header" [ngModel]="value(col)"
        (keyup.enter)="pick(col, t.value, pop)" />
      <button type="button" pButton class="p-button p-button-primary" label="Applica"
        (click)="pick(col, t.value, pop)"></button>
    </div>
  }
</ng-template>
